import Vue from 'vue'
import VueRouter from 'vue-router'
import route from './routes.js'

Vue.use(VueRouter)
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}


// 路由配置
const RouterConfig = {
    mode: 'history',
    routes: route,
};

// 路由定义
 const router = new VueRouter(RouterConfig);

const findPath = ((path)=>{
    var menuItem = JSON.parse(localStorage.getItem("menuItem"));

    var findPath = false
    var findButton = (menuItem)=>{
            menuItem.map((item)=>{
                if (item.subclass.length > 0) {
                    findButton(item.subclass);
                }else{
                    findPath = true
                    return
                }
            });
    };
    findButton(menuItem);
    return findPath;
});


// 路由设置
router.beforeEach((to, from, next) => {
  if(to.meta.title){//判断是否有标题
    document.title = to.meta.title
  }
  var userInfo = localStorage.getItem("userInfo");
  if(userInfo){
      if(to.path == "/home"){
        next()
      }else{
        var menuPower = findPath(to.path);
        console.log(menuPower)
        if(menuPower && to.matched.length != 0 && to.meta.type == "已登录") {
            next();
        }else{
            next("/home");
        }
      }
  }else{
      if(to.matched.length != 0 && to.meta.type == "未登录"){
          next();
      }else{
          next("/login");
      }
  }
});

router.afterEach((to) => {
  // window.scrollTo(0, 0);
});

// 暴露路由
export default router;



// WEBPACK FOOTER //
// ./src/router/config.js